import React from 'react';

import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { PageWidgetWrapperChildProps } from 'components/common/PageWidgetWrapper/usePageWidgetWrapperProps';

import { Tabs } from 'components/DesignSystem/Tabs';
import { ActivityLevelDrivers } from 'components/widgets/ActivityLevelDrivers/ActivityLevelDrivers';
import { DistributionGraph } from 'components/widgets/DistributionGraph/DistributionGraph';
import { RiskDrivers } from 'components/widgets/RiskDrivers/RiskDrivers';
import { RiskRegister } from 'components/widgets/RiskRegister/RiskRegister';
import { useRiskRegisterTabsLogic } from 'components/widgets/RiskRegisterTabs/RiskRegisterTabs.logic';
import classes from 'components/widgets/RiskRegisterTabs/RiskRegisterTabs.module.scss';

type QsraChartTabLayoutProps = PageWidgetWrapperChildProps & {
    activeTab: 'chart' | 'table';
};

const QsraChartTabLayout = ({ activeTab, ...pageProps }: QsraChartTabLayoutProps) => (
    <div
        className={`${classes.qsraChartLayout} ${activeTab !== 'chart' ? classes.qsraChartLayoutHidden : ''}`}
        aria-hidden={activeTab !== 'chart'}
    >
        <DistributionGraph activeTab={activeTab} {...pageProps} />
        <div className={classes.driversColumns}>
            <div className={classes.driversColumn}>
                <RiskDrivers activeTab={activeTab} {...pageProps} />
            </div>
            <div className={classes.driversColumn}>
                <ActivityLevelDrivers activeTab={activeTab} {...pageProps} />
            </div>
        </div>
    </div>
);

export const RiskRegisterTabs = () => {
    const { logic } = useRiskRegisterTabsLogic();

    return (
        <>
            <Tabs
                tabs={logic.tabsList}
                value={logic.activeTab}
                onChange={(value) => logic.setActiveTab(value as 'table' | 'chart')}
            />
            <div className={classes.container}>
                <PageWidgetWrapper>
                    <RiskRegister activeTab={logic.activeTab} />
                    <QsraChartTabLayout activeTab={logic.activeTab} />
                </PageWidgetWrapper>
            </div>
        </>
    );
};
